import { render, staticRenderFns } from "./campSignupList.vue?vue&type=template&id=5c82b2fa&scoped=true&"
import script from "./campSignupList.vue?vue&type=script&lang=js&"
export * from "./campSignupList.vue?vue&type=script&lang=js&"
import style0 from "./campSignupList.vue?vue&type=style&index=0&id=5c82b2fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c82b2fa",
  null
  
)

export default component.exports